import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import InvoicesPage from "./InvoicesPage";
import PaymentsPage from "./PaymentsPage";
import ConnectOnboarding from "./ConnectOnboarding";
import "./FinancePage.css";

const FinancePage = () => {
  return (
    <div className="finance-shell">
      <Routes>
        <Route path="invoices" element={<InvoicesPage />} />
        <Route path="payments" element={<PaymentsPage />} />
        <Route path="payments-setup" element={<ConnectOnboarding />} />
        {/* Subscriptions, Pricing, and Billing remain hidden until backend endpoints exist */}
        <Route path="*" element={<Navigate to="invoices" replace />} />
      </Routes>
    </div>
  );
};

export default FinancePage;
